import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  path?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="text-xs text-foreground-500">
      <ol className="flex flex-wrap items-center gap-1.5">
        {items.map((item, index) => (
          <li key={`${item.label}-${index}`} className="flex items-center gap-1.5">
            {item.path ? (
              <Link to={item.path} className="transition-colors hover:text-primary-700">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700">{item.label}</span>
            )}
            {index < items.length - 1 && (
              <span className="w-3.5 h-3.5 flex items-center justify-center text-foreground-300">
                <i className="ri-arrow-right-s-line" aria-hidden="true" />
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}